import { render, staticRenderFns } from "./xqgk_menu.vue?vue&type=template&id=c184550c&scoped=true&"
import script from "./xqgk_menu.vue?vue&type=script&lang=js&"
export * from "./xqgk_menu.vue?vue&type=script&lang=js&"
import style0 from "./xqgk_menu.vue?vue&type=style&index=0&id=c184550c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c184550c",
  null
  
)

export default component.exports